import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { List, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { withTenant, withTranslate } from "../../core/TenantProvider";
import { ReactComponent as AustraliaIcon } from "./assets/countries/australia.svg";
import { ReactComponent as FranceIcon } from "./assets/countries/france.svg";
import { ReactComponent as ItalyIcon } from "./assets/countries/italy.svg";
import { ReactComponent as SouthAfricaIcon } from "./assets/countries/south-africa.svg";
import { ReactComponent as SpainIcon } from "./assets/countries/spain.svg";
import { ReactComponent as UAEIcon } from "./assets/countries/united-arab-emirates.svg";
import { ReactComponent as UpArrowIcon } from "./assets/icons/icon-chevron-up.svg";
import { ReactComponent as DownArrowIcon } from "./assets/icons/icon-chevron-down.svg";
import POIDocumentsContainerStyles from './styles/POIDocumentsContainer.style';
import APHeading from "../../components/atoms/APHeading";
import { GoogleAnalyticTags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../core/utils/GoogleAnalyticTag';
import { GoogleAnalytics4Tags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';

interface POIDocumentsContainerProps extends WithStyles<typeof POIDocumentsContainerStyles> {
    translate: Function
}

interface POIDocumentsContainerState {
    currentExpandedPanel: string
}

class POIDocumentsContainer extends Component<POIDocumentsContainerProps, POIDocumentsContainerState> {
    constructor(props) {
        super(props);
        this.state = {
            currentExpandedPanel: 'panel0',
        }
    }

    handleChange(panel: string) {
        return ((event: React.ChangeEvent<{}>, isExpanded: boolean) => {
            this.setState({
                currentExpandedPanel: isExpanded ? panel : ''
            });
        });
    }

    componentDidMount() {
        TriggerGoogleAnalyticsTag(
            GoogleAnalyticTags.eventAction.click,
            GoogleAnalyticTags.registration.click.identityDocumentOptionsByCountry
        );
        TriggerGoogleAnalytics4Tag(
            GoogleAnalytics4Tags.registerClient.name,
            GoogleAnalytics4Tags.eventAction.click,
            GoogleAnalytics4Tags.registerClient.click.identityDocumentOptionsByCountry
        );
    }

    render() {
        const {
            classes,
            translate,
        } = this.props;

        const requiredDocuments = [
            { paragraph: "Citizen's permit, social security card, visa", country: "Spain", icon: <SpainIcon /> },
            { paragraph: "Resident's permit, Carte de Sejour, visa", country: "France", icon: <FranceIcon /> },
            { paragraph: "Citizen's permit", country: "Italy", icon: <ItalyIcon /> },
            { paragraph: "Resident's permit, social security cards, visa", country: "South Africa", icon: <SouthAfricaIcon /> },
            { paragraph: "International driving permit, citizen's certificate, benefit statement, pension document, visa, certified birth certificate, card issued for the person's age", country: "Australia", icon: <AustraliaIcon /> },
            { paragraph: "International driving permit, citizen's certificate, benefit statement, pension document, visa, certified birth certificate, card issued for the person's age", country: "UAE", icon: <UAEIcon /> }
        ];

        return (
            <div>
                <div className={classes.headerSurround}>
                    <APHeading className={classes.heading}>
                        {translate('poi.menu.heading')}
                    </APHeading>
                    <p className={classes.subHeading}>
                        {translate('poi.menu.subHeading')}
                    </p>
                </div>
                <List className={classes.list} aria-label={translate('poi.menu.heading')}>
                    {requiredDocuments.map((item: any, index) => (
                        <Accordion className={classes.poiBulletPoints}
                            expanded={this.state.currentExpandedPanel === (`panel${index}`)}
                            onChange={this.handleChange((`panel${index}`))}>
                            <AccordionSummary className={classes.poiSummary} aria-controls={`panel${index}d-content`} id={`panel${index}d-header`}>
                                <li className={classes.poiBullet}>
                                    <span className={classes.flag}>{item.icon}</span>
                                    <span className={classes.countryLabel}>{item.country}</span>
                                    <span className={classes.directionalArrows}> {this.state.currentExpandedPanel === `panel${index}` ? <UpArrowIcon /> : <DownArrowIcon />}</span>
                                </li>
                            </AccordionSummary>
                            <AccordionDetails className={classes.poiDetails}>
                                <li className={classes.paragraphSurround}>
                                    <span>{item.paragraph}</span>
                                </li>
                            </AccordionDetails>
                        </Accordion>
                    ))
                    }
                </List>
            </div >
        );
    }
}

export default (
    withTenant(
        withTranslate(
            withStyles(POIDocumentsContainerStyles)(
                POIDocumentsContainer
            )
        )
    )
);
